import { NodeTypes } from '@ravago/shared/page-data/enums/node-types';

import kebabCase from 'lodash/kebabCase';

export class AppUtils {
   static getKey(nodeId: string, identifier: string | number): string {
      return `${nodeId}-${identifier}`;
   }

   static firstLetterToLowerCase(value: string): string {
      if (value.length === 0) return value;

      return value[0].toLowerCase() + value.slice(1);
   }

   static getTestSelector(defaultValue: string, type: NodeTypes, prefix?: string): string {
      return kebabCase(`${prefix ? `${prefix}-` : ''}${defaultValue}-${type}`);
   }
}
